import { useI18n } from 'contexts/i18n';
import Link from 'next/link';
import { FC } from 'react';
import { Styled, BreadcrumbProps } from './';

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  const i18n = useI18n();
  let crumbItems = items;

  crumbItems = crumbItems.map(k => {
    return {
      ...k,
      permalink:
        k.permalink === '/' ||
        k.permalink === '/cartview?showcart=1' ||
        k.permalink === '' ||
        k.permalink === '/orderhistorylog' ||
        k.permalink === '/customcase' ||
        k.permalink.includes('/iteroscanners')
          ? k.permalink
          : `/category/${k.permalink}`,
    };
  });
  return (
    <Styled.BreadcrumbContainer>
      {crumbItems.map(
        (item: { name: string; permalink: string }, index: number) => {
          const isLastItem = index == items.length - 1;
          return (
            <div key={item.name}>
              {item.permalink.length > 0 ? (
                <Link href={item.permalink} passHref legacyBehavior>
                  <Styled.ItemTitle
                    isLink={true}
                    className="breadcrumb-item-gtm"
                  >
                    {i18n[item.name] ? i18n[item.name] : item.name}
                  </Styled.ItemTitle>
                </Link>
              ) : (
                <Styled.ItemTitle isLink={false}>
                  {i18n[item.name] ? i18n[item.name] : item.name}
                </Styled.ItemTitle>
              )}
              {!isLastItem && <Styled.Separator> | </Styled.Separator>}
            </div>
          );
        }
      )}
    </Styled.BreadcrumbContainer>
  );
};

export default Breadcrumb;
